var toFormData = function toFormData(object) {
	var formData = new FormData();
	Object.keys(object).forEach(function (key) {
		return formData.append(key, object[key]);
	});
	return formData;
};

var index = (function (url, data) {
	var spec = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	var xhr = new XMLHttpRequest();

	var upload = new Promise(function (resolve, reject) {
		var headers = spec.headers,
		    _spec$method = spec.method,
		    method = _spec$method === undefined ? 'POST' : _spec$method,
		    onProgress = spec.onProgress,
		    _spec$withCredentials = spec.withCredentials,
		    withCredentials = _spec$withCredentials === undefined ? false : _spec$withCredentials;


		if (typeof onProgress === 'function') {
			xhr.upload.onprogress = function (event) {
				onProgress(event.loaded / event.total);
			};
		}

		xhr.onload = function () {
			var response = void 0;

			try {
				response = JSON.parse(xhr.response);
			} catch (err) {
				response = xhr.response;
			}

			if (xhr.status >= 200 && xhr.status < 300) {
				resolve(response);
				return;
			}
			reject(response);
		};

		xhr.onerror = function (err) {
			reject(err);
		};

		xhr.onabort = function () {
			reject({ code: 'CANCELLED' });
		};

		xhr.open(method, url);
		xhr.withCredentials = withCredentials;

		if (headers) {
			Object.keys(headers).forEach(function (header) {
				return xhr.setRequestHeader(header, headers[header]);
			});
		}

		xhr.send(toFormData(data));
	});

	return {
		// $FlowFixMe - extending builtins is hard
		then: function then(onResolve, onReject) {
			return upload.then(onResolve, onReject);
		},
		// $FlowFixMe - extending builtins is hard
		catch: function _catch(onReject) {
			return upload.catch(onReject);
		},
		cancel: function cancel() {
			xhr.abort();
		}
	};
});

export default index;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@livechat/file-upload/dist/file-upload.es.js
// module id = 539
// module chunks = 0